import {
  arrayRemove,
  doc,
  type Firestore,
  getDoc,
  updateDoc,
} from 'firebase/firestore';
import type { Profile } from '@/service/profile/types';

export default class GroupService {
  constructor(
    private readonly firestore: Firestore,
    private readonly uid: string,
  ) {}

  async getMembers(): Promise<string[]> {
    const snapshot = await getDoc(doc(this.firestore, 'groups', this.uid));
    if (!snapshot.exists()) return [];
    const users: string[] = snapshot.data().users ?? [];
    return users.filter((uid) => uid !== this.uid);
  }

  async getMemberProfiles(): Promise<Profile[]> {
    const memberUids = await this.getMembers();
    const profiles: Profile[] = [];
    for (const uid of memberUids) {
      const snapshot = await getDoc(doc(this.firestore, 'users', uid));
      if (snapshot.exists()) {
        profiles.push(snapshot.data() as Profile);
      }
    }
    return profiles;
  }

  async removeMember(memberUid: string): Promise<void> {
    await updateDoc(doc(this.firestore, 'groups', this.uid), {
      users: arrayRemove(memberUid),
    });
    await updateDoc(doc(this.firestore, 'groups', memberUid), {
      users: arrayRemove(this.uid),
    });
  }

  async getProfilesByUids(uids: string[]): Promise<Profile[]> {
    const profiles: Profile[] = [];
    for (const uid of uids) {
      const snapshot = await getDoc(doc(this.firestore, 'users', uid));
      if (snapshot.exists()) {
        profiles.push(snapshot.data() as Profile);
      }
    }
    return profiles;
  }
}
